import React from 'react';
import { Tooltip } from 'antd';
import { ReactComponent as ZoomOutSVG } from '../icons/minus.svg';

export const ZoomOut: React.FC<{ onZoomOut: VoidFunction }> = ({ onZoomOut }) => {
  return (
    <Tooltip key={4} placement="top" title="Zoom Out (Cmd -)">
      <ZoomOutSVG onClick={onZoomOut} />
    </Tooltip>
  );
};
